import script from "./reader.vue?vue&type=script&setup=true&lang=js"
export * from "./reader.vue?vue&type=script&setup=true&lang=js"

import "./reader.vue?vue&type=style&index=0&id=0f220356&lang=scss&scoped=true"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f220356"]])

export default __exports__